/**
 * Pure SMS user-filtering logic shared between server and pipeline Lambda.
 *
 * No Clerk, no AWS, no side-effects — just types, constants, and filters.
 * The Clerk-dependent "fetch all consented users" step lives in each consumer.
 */

export const SMS_FEATURE_LAUNCH_DATE = new Date("2026-02-05");

export const SMS_MAX_MESSAGE_LENGTH = 270;

export type SmsFilter = "all" | "post-pilot" | "internal";

export interface UserPreview {
  userId: string;
  firstName: string | null;
  lastName: string | null;
  email: string;
  phone: string;
  createdAt?: number;
}

/**
 * Apply a named filter to a list of consented users.
 */
export function applyFilter(
  users: UserPreview[],
  filter: SmsFilter,
): UserPreview[] {
  switch (filter) {
    case "all":
      return users;
    case "post-pilot":
      return users.filter(
        (u) => u.createdAt != null && new Date(u.createdAt) >= SMS_FEATURE_LAUNCH_DATE,
      );
    case "internal":
      return users.filter((u) =>
        u.email.toLowerCase().endsWith("@onsemble.com"),
      );
  }
}
